/* eslint-disable no-mixed-operators */
import { Formik, Form, Field } from 'formik';
import { useState, useEffect, useCallback } from 'react';
import * as yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import { FiMail, FiPhone, FiUser } from 'react-icons/fi';
import { DefaultTheme, useTheme } from 'styled-components';
import { toast } from 'react-toastify';
import { useParams, useHistory } from 'react-router-dom';
import { useRef } from 'react';
import { Breadcrumb } from '../../../components/Breadcrumb';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { ReactSelect } from '../../../components/ReactSelect';
import api from '../../../services/api';
import { IUser } from '../../../interfaces/IUser';
import { InputFormat } from '../../../components/Input/Format';
import { ISelect } from '../../../interfaces/ISelect';

const dataInitial = {
  name: '',
  email: '',
  phone: '',
  role: '',
  clientId: '',
};

interface SubmitProps {
  email: string;
  role: any;
  clientId: any;
}

const schema = yup.object({
  name: yup.string().required('Digite o nome'),
  phone: yup.string().required('Digite o telefone'),
  email: yup
    .string()
    .email('Digite um email válido')
    .required('Digite seu email'),
  role: yup.lazy(value => {
    if (typeof value === 'object') {
      return yup.object().nullable().required('Campo obrigatório');
    }
    return yup.string().required('Campo obrigatório');
  }),
});

export const FormUser = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<IUser>();
  const theme: DefaultTheme = useTheme();
  const [clients, setClients] = useState<ISelect[]>([]);

  const handleSubmit = async (data: SubmitProps) => {
    try {
      setLoading(true);
      if (id) {
        if (
          ((data.role.value === 'CLIENT' || data.role === 'CLIENT') &&
            data.clientId.value === undefined) ||
          ((data.role.value === 'CLIENT' || data.role === 'CLIENT') &&
            data.clientId === undefined)
        ) {
          toast.error('selecione o cliente');
          return;
        }
        await api.put(`/users/${id}`, {
          ...data,
          profile: 'Qualquer',
          role: data.role.value || data.role,
          clientId: data.clientId.value || data.clientId,
        });
      } else {
        if (
          (data.role.value === 'CLIENT' && data.clientId.value === undefined) ||
          (data.role.value === 'CLIENT' && data.clientId === undefined)
        ) {
          toast.error('selecione o cliente');
          return;
        }
        await api.post('/users', {
          ...data,
          profile: 'Qualquer',
          role: data.role.value,
          clientId: data.clientId.value,
        });
      }
      toast.success('Usuário salvo com sucesso');
      history.push('/users');
    } catch (err: any) {
      if (err.response.data.message) {
        toast.error(err.response.data.message);
        return;
      }
      toast.error('Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      api
        .get(`/users/${id}`)
        .then(({ data }) => setUser(data))
        .catch(() => toast.error('Erro ao buscar usuário'));
    }

    api
      .get('/clients?isAll=true')
      .then(({ data }) =>
        setClients(
          data.map((item: any) => ({
            label: item.name,
            value: item.id,
          })),
        ),
      )
      .catch(() => toast.error('Erro ao buscar clients'));
  }, [id]);
  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: 'Usuários',
            link: '/users',
          },
          {
            title: id ? 'Editar usuário' : 'Cadastro de usuário',
          },
        ]}
      />
      <Row className="d-flex align-items-center mt-4">
        <Col md={10} xs={9}>
          <h3>{id ? 'Editar usuário' : 'Novo usuário'}</h3>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col md={{ span: 6, offset: 3 }}>
          <Formik
            initialValues={user || dataInitial}
            enableReinitialize
            onSubmit={handleSubmit}
            validationSchema={schema}
          >
            {({ values }) => (
              <Form>
                <Field
                  name="role"
                  placeholder="Tipo de usuário"
                  component={ReactSelect}
                  options={[
                    {
                      label: 'Administrador',
                      value: 'ADMIN',
                    },
                    {
                      label: 'Cliente',
                      value: 'CLIENT',
                    },
                  ]}
                />
                {(values.role.value !== 'CLIENT' && user?.role !== 'CLIENT') ||
                  (values.role.value === undefined && user === undefined) ||
                  (values.role.value !== 'CLIENT' &&
                    values.role.value !== undefined &&
                    user?.role === 'CLIENT') ||
                  (values.role.value !== 'CLIENT' && user === undefined) || (
                    <Field
                      name="clientId"
                      placeholder="Cliente"
                      component={ReactSelect}
                      options={clients}
                    />
                  )}
                <Input
                  type="text"
                  name="name"
                  icon={FiUser}
                  placeholder="Nome completo"
                />
                <InputFormat
                  name="phone"
                  placeholder="Telefone"
                  icon={FiPhone}
                  format="(##) #####-####"
                  mask="_"
                />

                <Input
                  type="email"
                  name="email"
                  icon={FiMail}
                  placeholder="Email"
                />
                <Col md={{ span: 6, offset: 3 }}>
                  <Button
                    className="mt-4"
                    type="submit"
                    background={theme.colors.secondary}
                    loading={loading}
                    color="#fff"
                  >
                    Salvar
                  </Button>
                </Col>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </div>
  );
};
